import { ApplicationConfig, ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideAnimations } from "@angular/platform-browser/animations";
import { routes } from "./app.routes";
import { provideHttpClient, withInterceptors, withInterceptorsFromDi, HTTP_INTERCEPTORS } from "@angular/common/http";
import { provideNgxMask } from "ngx-mask";
import { LocationStrategy, PathLocationStrategy } from "@angular/common";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { httpErrorInterceptor } from "@core/interceptors/http-error.interceptor";
import { JwtInterceptor } from "@core/interceptors/jwt.interceptor";
import { ChunkErrorHandler } from "@core/services/chunk-error-handler.service";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    provideAnimations(),
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([httpErrorInterceptor])
    ),
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    provideNgxMask(),
    importProvidersFrom(MatDatepickerModule, MatNativeDateModule),
    { provide: ErrorHandler, useClass: ChunkErrorHandler }
  ],
};
